import React, {Component} from 'react';
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";

import classes from './NotificationsButton.module.css';
import {connect} from "react-redux";
import * as actionTypes from "../../../store/actions/actionTypes";
import {Notifications, UnreadNotifications} from "../../Icons/Icons";
import apiUrl from "../../../shared/config";
import axios from "axios";


class NotificationsButton extends Component {

    state = {
        notificationLoadInterval: 0,
        shouldSetInterval: false,
        userActive: false,
    }

    componentDidMount() {
        if (this.props.isInToolbar && this.props.token) {
            this.setState({shouldSetInterval: true})
        }
    }

    componentWillUnmount() {
        if (this.props.isInToolbar) {
            clearInterval(this.state.notificationLoadInterval)
        }
    }

    fetchNewNotificationsHandler(clicked) {
        if ((this.state.userActive || clicked) && this.props.token) {
            let params = {
                params: {
                    fetched_timestamp: this.props.notifications.fetched_timestamp
                }
            }

            axios.get(apiUrl + 'Users/fetchNewNotifications?token=' + this.props.token, params)
                .then(response => {
                    let updated_notifications = {
                        fetched_timestamp: response.data.fetched_timestamp,
                        notifications: [
                            ...response.data.notifications.concat(
                                ...this.props.notifications.notifications)
                        ],
                        hidden_content: response.data.hidden_content,
                        no_contact_email_content: response.data.no_contact_email_content
                    }
                    this.props.updateNotifications(updated_notifications)
                })
            this.setState({userActive: false})
        } else {
            clearInterval(this.state.notificationLoadInterval)
            this.setState({userActive: false, notificationLoadInterval: 0})
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.isInToolbar && this.props.token) {
            const setActive = () => {
                if (!this.state.userActive && !this.state.notificationLoadInterval) {
                    this.setState({userActive: true, shouldSetInterval: true})
                    this.fetchNewNotificationsHandler(false)
                } else if (!this.state.userActive) {
                    this.setState({userActive: true})
                }
            };
            window.onload = setActive;
            document.onmousemove = setActive;
            document.onmousedown = setActive;
            document.onkeydown = setActive;
            document.onkeyup = setActive;
            document.onscroll = setActive;
        }

        if (this.props.token && this.props.isAuthenticated && this.props.isInToolbar && this.state.shouldSetInterval) {
            let notificationInterval = setInterval(() => this.fetchNewNotificationsHandler(false), 600000)
            this.setState({notificationLoadInterval: notificationInterval, shouldSetInterval: false})
        }
    }


    unreadNotificationCount = () => {
        let notifications = (this.props.notifications.notifications ?? [])
        const unreadNotifications = notifications.filter((notif) => {return !notif.hasBeenViewed})
        const perpetualNotificationCount =
            (this.props.notifications.hidden_content && this.props.notifications.hidden_content.length > 0 ? 1 : 0)
            + (this.props.notifications.no_contact_email_content
            && Object.keys(this.props.notifications.no_contact_email_content).length > 0 ? 1 : 0)
        if (unreadNotifications) {
            return unreadNotifications.length + perpetualNotificationCount
        } else {
            return 0 + perpetualNotificationCount
        }
    }

    handleOnClick = (buttonIsActive) => {
        this.fetchNewNotificationsHandler(true)
        if (buttonIsActive) {
            this.props.openNotifications();
        }
    }

    render() {
        return (
            <>
                <OverlayTrigger
                    trigger={['hover', 'focus']}
                    rootClose
                    rootCloseEvent="click"
                    key={'notifications-button'}
                    placement='bottom'
                    overlay={
                        <Popover id={'notifications-popover'}>
                            <Popover.Title as="h3">{!this.unreadNotificationCount() ? "No " : ''}Notifications {this.unreadNotificationCount() === 0 ? '' : ': ' + this.unreadNotificationCount() + ' Unread'}</Popover.Title>
                            <Popover.Content className="pattern-exercise-description">
                                {!this.unreadNotificationCount() ? "You currently have no" : 'Click here to read'} notifications regarding activity on your patterns
                            </Popover.Content>
                        </Popover>
                    }
                >
                    <div
                        className={!this.unreadNotificationCount() ? classes.disabledButton : classes.notificationsButton + ' ' + classes.clickable}
                        key={'notifications-icon'}
                        onClick={() => this.handleOnClick(this.unreadNotificationCount() !== 0)}
                    >
                        {this.unreadNotificationCount() === 0
                            ? <Notifications style={{marginBottom: 2, marginLeft: 5, transform: "scale(1.4)"}}/>
                            : <span style={{alignItems: "center", display: "flex", whiteSpace: "pre-line"}}>{this.unreadNotificationCount()} <UnreadNotifications style={{marginBottom: 2, marginLeft: 5, transform: "scale(1.4)"}}/></span>}
                    </div>
                </OverlayTrigger>
            </>
        );
    }
}

const mapStateToProps = state => {
    return {}
}

const mapDispatchToProps = dispatch => {
    return {
        updateNotifications: (updated_notifications) => dispatch({type: actionTypes.UPDATE_NOTIFICATIONS, value: updated_notifications})
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(NotificationsButton);